import React from 'react';
import { Icon } from '../icon';
import { IconProps } from '../icon/Icon';
import { cn } from '@ui/lib';

interface ButtonContentProps {
  labelText: string;
  loadingText?: string;
  leadingIcon?: Pick<IconProps, 'fileName'>;
  trailingIcon?: Pick<IconProps, 'fileName'>;
  format?: 'small' | 'full' | 'marketing';
}

export const ButtonContent: React.FC<ButtonContentProps> = ({
  labelText,
  leadingIcon,
  trailingIcon,
  loadingText = '',
  format,
}) => {
  return (
    <>
      {leadingIcon && <Icon size="md" {...leadingIcon} />}
      <Icon
        size="md"
        fileName="ic_loading"
        className="loading-icon animate-spin"
      />
      <span className="flex items-center justify-center">
        {labelText && (
          <span
            className={cn('label-text', {
              'text-sm font-medium leading-none': format === 'small',
            })}
          >
            {labelText}
          </span>
        )}
        {/* Negative margin compensates for the right arrow SVG's inner space,
            ensuring the visual gap between text and icon is ~4px as intended. */}
        <Icon
          size="md"
          fileName="ic_right_arrow"
          // eslint-disable-next-line tailwindcss/no-arbitrary-value, tailwindcss/enforces-negative-arbitrary-values
          className="hover-icon"
        />
      </span>
      {loadingText && <span className="loading-text">{loadingText}</span>}
      {trailingIcon && <Icon size="md" {...trailingIcon} />}
    </>
  );
};
